import ErrorLayer from "../components/ErrorLayer";

const ErrorPage = () => {
  return <ErrorLayer />;
};

export default ErrorPage;
